import { ProductTokens } from '../types'
import { colors } from './colors'

export const perthnow: ProductTokens = {
    colors,
}
